import type { ReactNode } from 'react'



import { cn } from '@/shared/lib/utils'

import { isVideoMediaUrl, resolveMediaDisplayUrl } from '@/shared/lib/media-proxy'



import { CATALOG_LIST_COVER_FALLBACK_ASPECT } from './catalogListGrid'



/** 固定封面槽 + 模糊衬底；无封面时同比例占位 */

const mediaShellClass = cn(

  'relative w-full shrink-0 overflow-hidden rounded-b-none',

  CATALOG_LIST_COVER_FALLBACK_ASPECT,

)



/** 背景层：放大裁切 + 模糊，消灭 letterbox 黑边 */

const mediaBackdropClass =

  'pointer-events-none absolute inset-0 h-full w-full scale-110 object-cover blur-2xl opacity-70 saturate-150'



/** 前景层：完整展示原图比例，hover 微缩放 */

const mediaForegroundClass =

  'max-h-full max-w-full object-contain transition duration-300 will-change-transform group-hover:scale-[1.03]'



type CatalogListCardMediaProps = {

  className?: string

  coverUrl?: string | null

  coverAlt?: string

  fallback: ReactNode

  children?: ReactNode

}



function CoverBackdrop({ displayUrl, coverIsVideo }: { displayUrl: string; coverIsVideo: boolean }) {

  if (coverIsVideo) {

    return (

      <video

        src={displayUrl}

        muted

        playsInline

        preload="metadata"

        draggable={false}

        aria-hidden

        className={mediaBackdropClass}

      />

    )

  }

  return <img src={displayUrl} alt="" draggable={false} aria-hidden className={mediaBackdropClass} />

}



function CoverForeground({

  displayUrl,

  coverAlt,

  coverIsVideo,

}: {

  displayUrl: string

  coverAlt: string

  coverIsVideo: boolean

}) {

  if (coverIsVideo) {

    return (

      <video

        src={displayUrl}

        muted

        playsInline

        preload="metadata"

        draggable={false}

        className={mediaForegroundClass}

      />

    )

  }

  return <img src={displayUrl} alt={coverAlt} draggable={false} className={mediaForegroundClass} />

}



export function CatalogListCardMedia({

  className,

  coverUrl,

  coverAlt = '',

  fallback,

  children,

}: CatalogListCardMediaProps) {

  const rawCover = String(coverUrl ?? '').trim()

  const displayUrl = rawCover ? resolveMediaDisplayUrl(rawCover) : ''

  const coverIsVideo = isVideoMediaUrl(rawCover)



  return (

    <div className={cn(mediaShellClass, className)}>

      {displayUrl ? (

        <>

          <CoverBackdrop displayUrl={displayUrl} coverIsVideo={coverIsVideo} />

          <div className="absolute inset-0 z-[1] flex items-center justify-center p-0.5">

            <CoverForeground displayUrl={displayUrl} coverAlt={coverAlt} coverIsVideo={coverIsVideo} />

          </div>

        </>

      ) : (

        <div className="absolute inset-0 flex items-center justify-center">{fallback}</div>

      )}

      {children ? <div className="relative z-[2]">{children}</div> : null}

    </div>

  )

}



export { mediaForegroundClass as mediaImageClass, mediaShellClass }



